<div class="form-floating" [class.is-invalid]="showError">
    <div class="input-group input-group-lg">
        <label class="input-group-text" [for]="field.id">Upload {{props.placeholder}}</label>
        <div class="file-control form-control d-flex flex-row justify-content-between" [class.is-invalid]="showError" [class.disabled]="isDisabled" [ariaDisabled]="isDisabled">
            <div class="file-name p-2">
                @if(uri) {
                <a [href]="uri" target="_blank" style="z-index: 100;">{{fileName}}</a>
                } @else {
                {{fileName}}
                }
            </div>
            @if(fileName) {
            <div class="remove-file py-2" [class.disabled]="isDisabled" (click)="removeFile()"><i class="bi bi-x-lg"></i></div>
            } @else {
            <form [formGroup]="form">
                <input class="file-input" type="file" [formControlName]="'file'" [disabled]="isDisabled" (change)="onInputChangeEvent($event.target)" (blur)="onTouch()">
            </form>
            }
        </div>
    </div>
</div>